import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import UserViewPreferences from './UserViewPreferences';
import PinModal from './PinModal';
import api from '../services/api';

const Layout = ({ children, user, onLogout, onViewPreferencesChange }) => {
  const [showViewPreferences, setShowViewPreferences] = useState(false);
  const [showPinModal, setShowPinModal] = useState(false);
  const [pinVerified, setPinVerified] = useState(false);

  // Manejar click en boton de preferencias (verificar PIN si existe)
  const handlePreferencesClick = async () => {
    try {
      const response = await api.get('/api/users/me/has-pin');
      if (response.data.hasPin && !pinVerified) {
        setShowPinModal(true);
      } else {
        setShowViewPreferences(true);
      }
    } catch (error) {
      console.error('Error checking PIN:', error);
      // Si hay error, intentar abrir directamente
      setShowViewPreferences(true);
    }
  };

  const handlePinSuccess = () => {
    setShowPinModal(false);
    setPinVerified(true);
    setShowViewPreferences(true);
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      {/* Header superior con navegación */}
      <header style={{ 
        background: '#1f2937', 
        color: 'white', 
        padding: '1rem',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '2rem' }}>
          <a 
            href="https://nubemotic.com.ar" 
            target="_blank" 
            rel="noopener noreferrer" 
            style={{ 
              textDecoration: 'none',
              display: 'flex',
              alignItems: 'center',
              gap: '0.75rem'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.querySelector('div').style.color = '#66ccff';
              e.currentTarget.querySelector('img').style.transform = 'scale(1.05)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.querySelector('div').style.color = '#00aaff';
              e.currentTarget.querySelector('img').style.transform = 'scale(1)';
            }}
          >
            <img 
              src="/logo-designerlow.png" 
              alt="NubeMotic" 
              style={{ 
                height: '40px',
                transition: 'transform 0.3s ease'
              }} 
            />
            <div style={{ 
              color: '#00aaff', 
              fontSize: '1.5rem', 
              fontWeight: 'bold',
              transition: 'color 0.3s ease'
            }}>
              IoT Integration
            </div>
          </a>
          <nav style={{ display: 'flex', gap: '1rem' }}>
            <button
              onClick={() => window.open('/Manual_Usuario_IoT_Platform.html', '_blank', 'width=1000,height=800,scrollbars=yes,resizable=yes')}
              style={{
                padding: '0.5rem 1rem',
                color: 'white',
                textDecoration: 'none',
                borderRadius: '4px',
                background: 'rgba(34, 197, 94, 0.2)',
                border: '1px solid rgba(34, 197, 94, 0.5)',
                transition: 'background 0.2s',
                cursor: 'pointer',
                fontSize: 'inherit',
                fontFamily: 'inherit'
              }}
              onMouseEnter={(e) => e.target.style.background = 'rgba(34, 197, 94, 0.4)'}
              onMouseLeave={(e) => e.target.style.background = 'rgba(34, 197, 94, 0.2)'}
              title="Manual de Usuario"
            >
              📖 Manual
            </button>
            <Link to="/alerts" style={{
              padding: '0.5rem 1rem',
              color: 'white',
              textDecoration: 'none',
              borderRadius: '4px',
              background: 'rgba(239, 68, 68, 0.2)',
              border: '1px solid rgba(239, 68, 68, 0.5)',
              transition: 'background 0.2s'
            }}>
              🚨 Alertas
            </Link>
            <Link to="/dashboard" style={{ 
              padding: '0.5rem 1rem', 
              color: 'white', 
              textDecoration: 'none', 
              borderRadius: '4px',
              background: 'rgba(255,255,255,0.1)',
              transition: 'background 0.2s'
            }}>
              📊 Dashboard
            </Link>
            {(user.role === 'admin' || user.role === 'operator') && (
              <Link to="/configuration" style={{
                padding: '0.5rem 1rem',
                color: 'white',
                textDecoration: 'none',
                borderRadius: '4px',
                background: 'rgba(255,255,255,0.1)',
                transition: 'background 0.2s'
              }}>
                ⚙️ Configuración
              </Link>
            )}
            {user.role === 'admin' && (
              <Link to="/mqtt-console" style={{
                padding: '0.5rem 1rem',
                color: 'white',
                textDecoration: 'none',
                borderRadius: '4px',
                background: 'rgba(255,255,255,0.1)',
                transition: 'background 0.2s'
              }}>
                🔌 Consola MQTT
              </Link>
            )}
            {user.role === 'admin' && (
              <Link to="/connection-logs" style={{
                padding: '0.5rem 1rem',
                color: 'white',
                textDecoration: 'none',
                borderRadius: '4px',
                background: 'rgba(168, 85, 247, 0.2)',
                border: '1px solid rgba(168, 85, 247, 0.5)',
                transition: 'background 0.2s'
              }}>
                📜 Logs Conexión
              </Link>
            )}
            {user.role === 'admin' && (
              <Link to="/clients" style={{
                padding: '0.5rem 1rem',
                color: 'white',
                textDecoration: 'none',
                borderRadius: '4px',
                background: 'rgba(14, 165, 233, 0.2)',
                border: '1px solid rgba(14, 165, 233, 0.5)',
                transition: 'background 0.2s'
              }}>
                💼 Clientes
              </Link>
            )}
          </nav>
        </div>
        
        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
          <span style={{ fontSize: '0.875rem' }}>
            {user.username} ({user.role})
          </span>
          <button
            onClick={handlePreferencesClick}
            title="Preferencias de visualización"
            style={{
              padding: '0.5rem 0.75rem',
              background: 'rgba(59, 130, 246, 0.2)',
              color: 'white',
              border: '1px solid rgba(59, 130, 246, 0.5)',
              borderRadius: '4px',
              cursor: 'pointer',
              fontSize: '1rem',
              transition: 'background 0.2s'
            }}
            onMouseEnter={(e) => e.target.style.background = 'rgba(59, 130, 246, 0.4)'}
            onMouseLeave={(e) => e.target.style.background = 'rgba(59, 130, 246, 0.2)'}
          >
            👁️
          </button>
          <button onClick={onLogout} style={{
            padding: '0.5rem 1rem',
            background: '#ef4444',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '0.875rem'
          }}>
            Cerrar Sesión
          </button>
        </div>
      </header>
      
      <main style={{ flex: 1, padding: '1rem', background: '#f9fafb' }}>
        {children}
      </main>
      
      {/* Footer con copyright */}
      <footer style={{
        background: '#1f2937',
        color: '#9ca3af',
        padding: '1rem',
        textAlign: 'center',
        fontSize: '0.875rem',
        borderTop: '1px solid rgba(255, 255, 255, 0.1)'
      }}>
        © {new Date().getFullYear()} RMI Electronica SRL - Todos los derechos reservados
      </footer>

      {/* Modal de PIN */}
      {showPinModal && (
        <PinModal
          isOpen={showPinModal}
          onClose={() => setShowPinModal(false)}
          onSuccess={handlePinSuccess}
          mode="verify"
        />
      )}

      {/* Modal de preferencias de visualización */}
      <UserViewPreferences
        isOpen={showViewPreferences}
        onClose={() => setShowViewPreferences(false)}
        onSave={(prefs) => {
          if (onViewPreferencesChange) {
            onViewPreferencesChange(prefs);
          }
        }}
      />
    </div>
  );
};

export default Layout;
